import React from 'react'
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import { cn } from '@/lib/utils'

export function InlineImageNodeView({ node, selected }: NodeViewProps) {
  const { src, alt = '', title = '', darkSrc, display = 'inline' } = node.attrs as {
    src: string
    alt?: string
    title?: string
    darkSrc?: string
    display?: 'inline' | 'original' | 'block'
  }
  
  const handleClick = (e: React.MouseEvent) => {
    // Prevent default to avoid editor losing focus
    e.preventDefault()
    e.stopPropagation()
  }
  
  // If there's a dark mode image, render both images
  if (darkSrc) {
    return (
      <NodeViewWrapper 
        as="span"
        className={cn(
          'inline-image-wrapper',
          display === 'block' && 'block'
        )}
        contentEditable={false}
      >
        <img
          src={src}
          alt={alt}
          title={title}
          data-dark-src={darkSrc}
          data-display={display}
          className={cn(
            'inline-image',
            `inline-image--${display}`,
            'light-image',
            selected && 'ProseMirror-selectednode'
          )}
          data-inline-image=""
          onClick={handleClick}
          draggable={false}
        />
        <img
          src={darkSrc}
          alt={alt}
          title={title}
          data-display={display}
          className={cn(
            'inline-image',
            `inline-image--${display}`,
            'dark-image',
            selected && 'ProseMirror-selectednode'
          )}
          data-inline-image=""
          onClick={handleClick}
          draggable={false}
        />
      </NodeViewWrapper>
    )
  }
  
  // Single image
  return (
    <NodeViewWrapper 
      as="span"
      className={display === 'block' ? 'block' : 'inline'}
      contentEditable={false}
    >
      <img
        src={src}
        alt={alt}
        title={title}
        data-display={display}
        className={cn(
          'inline-image',
          `inline-image--${display}`,
          selected && 'ProseMirror-selectednode'
        )}
        data-inline-image=""
        onClick={handleClick}
        draggable={false}
      />
    </NodeViewWrapper>
  )
}